import { useState, useEffect } from 'react';

/**
 * A custom React hook for form validation.
 * @param {object} initialState - The initial state of the form fields.
 * @param {function} validate - A function that contains the validation logic.
 * @param {function} callback - The function to call when the form is successfully submitted.
 * @returns {object} An object containing form state and handlers.
 */
const useFormValidation = (initialState, validate, callback) => {
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isSubmitting) {
      const noErrors = Object.keys(errors).length === 0;
      if (noErrors) {
        callback(values);
        setIsSubmitting(false);
      } else {
        setIsSubmitting(false);
      }
    }
  }, [errors, isSubmitting, callback, values]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleAddressChange = (address) => {
    setValues({
      ...values,
      address,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validate(values);
    setErrors(validationErrors);
    setIsSubmitting(true);
  };

  return {
    handleSubmit,
    handleChange,
    handleAddressChange,
    values,
    setValues,
    errors,
    isSubmitting,
  };
};

export default useFormValidation;
